<template>
  <div class="exam-page">
    <my-breadcrumb :items="pagination"></my-breadcrumb>
    <div class="exam-container">
      <div>
        <img src="/img/icons/post-exam.svg" alt="" />
        <h3 class="color-white mt-3 text-center">{{tryout.name}}</h3>
        <p class="color-white">
          {{tryout.total_question}} soal
        </p>

        <my-button type="teal" @click="startModal = true" class="mt-3">
          <fa-icon icon="play" class="mr-1"></fa-icon>
          Mulai Tryout
        </my-button>
      </div>
    </div>

    <b-modal v-model="startModal" hide-footer hide-header centered>
      <modal-close @click="startModal = false"></modal-close>
      <div class="p-4 text-center">
        <img src="/img/icons/mulai-exam.svg" alt="" />
        <h3 class="text-center mt-3">Mulai Tryout</h3>
        <p>Apakah kamu yakin untuk memulai tryout sekarang?</p>
        <p class="passing-grade mt-2">
          
        </p>

        <my-button class="mr-2 mt-4" type="fill-blue" @click="handleYaClick">
          Ya
        </my-button>

        <my-button @click="startModal = false">
          Batal
        </my-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../store/types";

export default {
  data() {
    return {
      collapsed: false,
      startModal: false
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN,
      tryout: types.TRYOUT
    }), 
    pagination() {
      return [
        {
          text: this.tryout.tryout_level,
          url: '#'
        },
        {
          text: this.tryout.name,
          url: '#'
        }
      ]
    }
  },
  mounted() {
  	if (this.isLoggedIn) {
      this.tryoutDetail();
    } else {
      var link = "/login"
      if(this.$route.params.tryout) {
        link += "?tryout=" + this.$route.params.tryout
      }
      this.$router.push(link);
    }
  },
  watch: {
  	isLoggedIn: function(newVal) {
  		if(newVal) {
  			this.tryoutDetail();
  		} else {
  			var link = "/login"
        if(this.$route.params.tryout) {
          link += "?tryout=" + this.$route.params.tryout
        }
        this.$router.push(link);
  		}
  	}
  },
  methods: {
    ...mapActions({
    	getTryoutDetail: types.GET_TRYOUT_DETAIL,
      getQuizList: types.GET_QUIZ_LIST,
      startTryout: types.START_TRYOUT
    }),
    handleYaClick() {
      if(this.tryout.package[0].id) {
        this.startTryout({id:this.$route.params.tryout})
        .then(response => {
          this.$router.push("/tryout/"+this.$route.params.tryout+"/package/"+this.tryout.package[0].id);
        }).catch(error => {
          this.showMessageBox(error, "Failed to get tryout", "danger");
        })
      } else {
        this.showMessageBox("Tidak ada paket soal tryout", "Gagal", "success")
      }
    },
    tryoutDetail() {
      this.getTryoutDetail(this.$route.params.tryout ? this.$route.params.tryout : 0)
      .then(response => {
        
      }).catch(error => {
        this.showMessageBox(error, "Failed to get tryout", "danger");
      })
    },
    showMessageBox(message, title, variant) {
      this.$bvModal.msgBoxOk(message, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: variant,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
      .then(value => {
        this.temp = value
      })
      .catch(err => {
        this.temp = err;
      });
    }
  }
};
</script>

<style>
.dashboard-page {
  padding: 33px;
}

.exam-container {
  height: calc(100vh - 175px);
  background-image: linear-gradient(
    59deg,
    #56c8ff 1%,
    #2190e9 53%,
    #00cbae 114%
  );

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.passing-grade {
  font-size: 12px;
  color: #009feb;
}
</style>
</style>
